import React from "react";
import { Box } from "@mui/material";
import "../icons/Icon.js";
import { CustomIcon } from "../icons/types.js";
import "../icons/ExpandMoreIcon.js";
const PopupIcon = /* @__PURE__ */ React.createElement(Box, { component: "span", className: CustomIcon.ArrowDown, fontSize: 10 });
const CloseIcon = /* @__PURE__ */ React.createElement(Box, { component: "span", className: CustomIcon.ArrowUp, fontSize: 10 });
export {
  CloseIcon,
  PopupIcon
};
//# sourceMappingURL=AutocompleteIcons.js.map
